module.exports = __webpack_public_path__ + "media/images/onboarding4-551afb74.png";